import {useGetEventLog} from '@/modules/system-logs/api/use-get-event-log'
import {EventLog} from '@cypro/engine/schema'
import {createContext, PropsWithChildren, useContext} from 'react'

interface State {
  log: EventLog
}

interface Props extends PropsWithChildren {
  log: EventLog
}

const EventLogContext = createContext<State>({} as State)

export function EventLogProvider({children, log: initialLog}: Props) {
  const [log] = useGetEventLog(initialLog.id)

  return <EventLogContext.Provider value={{log: log || initialLog}}>{children}</EventLogContext.Provider>
}

export function useEventLogContext() {
  return useContext(EventLogContext)
}
